import React, { Component } from 'react';
import { InView } from 'react-intersection-observer';

import './SectionWrapper.css'

class Section extends Component {


    constructor(props) {
        super(props)

        this.state = {
            isVisible: false,
            pullUp: this.props.pullUp || false
        }

        this.onChange = this.onChange.bind(this)
    }

    onChange(inView) {

        this.setState({
            isVisible: inView
        })

    }


    render() {

        const { isVisible, pullUp } = this.state
        const { offset, threshold } = this.props

        // Convert offset to rootMargin format for IntersectionObserver
        const rootMargin = offset ? `${offset.top || 0}px ${offset.right || 0}px ${offset.bottom || 0}px ${offset.left || 0}px` : '0px'

        const sectionStyle = {
            opacity: isVisible ? 1 : 0,
            ...( pullUp && { transform: isVisible && pullUp ? 'scale(1)' : 'scale(0.85)' })
        }

        return (

            <InView onChange={this.onChange} rootMargin={rootMargin} triggerOnce={false} threshold={threshold || 0}>
                {({ ref }) => (
                    <section ref={ref} style={sectionStyle} className={isVisible ? 'active' : ''}>
                        {this.props.children}
                    </section>
                )}
            </InView>

        );
    }
}

export default Section;
